// BUG-2579: the cashier picks a sale type (GPR "Ek Second") on an empty cart, then scans or
// retrieves an estimate. The retrieve replaces the whole cart, customer included, while the
// sale type stays selected (usePOSConfigStore.saleTypeData). The bill went out under that sale
// type with the estimate's walk-in customer: 128 of 132 wrong Ek Second bills on live GPR
// (30 days to 2026-10-15). handleSelectedSaleType puts the sale type's customer on the cart;
// this does the same for a retrieved estimate.
//
// Applied only when ALL hold:
//   - the selected sale type is not a default one (isdefault "N") and has a customer;
//   - the estimate's customer is a walk-in (none, the store default or a sale type's customer);
//   - the estimate's customer carries no B2B buyer (isB2bEnabled "Y" / newB2bCustomerId):
//     GPR bills B2B on the walk-in with the buyer's company (BUG-2601).
// Prices are kept as the estimate has them (the estimate is what the customer was quoted).
import usePOSConfigStore from "../stores/usePOSConfigStore";
import { isWalkInCustomer, loadSaleTypeCustomerIds } from "./walkInCustomer";
import { trace } from "./debugTrace";

export const saleTypeCustomerFor = (saleTypeData) => {
  const saleType = saleTypeData?.cwrSaletype;
  const customer = saleTypeData?.customer;
  if (!saleType || saleType.isdefault !== "N" || !customer?.b2cCustomerId) return null;
  return { ...customer, cwrCustomerId: customer.cwrCustomerId || customer.b2cCustomerId };
};

const carriesB2bBuyer = (customer) => customer?.isB2bEnabled === "Y" || !!customer?.newB2bCustomerId;

// Returns the customer to put on the retrieved cart, or null to keep the estimate's own.
export const resolveEstimateSaleTypeCustomer = (cartData, tillData, saleTypeCustomerIds, saleTypeData = usePOSConfigStore.getState().saleTypeData) => {
  const saleTypeCustomer = saleTypeCustomerFor(saleTypeData);
  if (!saleTypeCustomer) return null;
  if (cartData?.customer?.cwrCustomerId === saleTypeCustomer.cwrCustomerId) return null;
  if (carriesB2bBuyer(cartData?.customer)) return null;
  if (!isWalkInCustomer(cartData?.customer, tillData, saleTypeCustomerIds)) return null;
  return saleTypeCustomer;
};

// Sets the selected sale type's customer on a retrieved estimate's cart (mutates cartData).
// db.posSaletypes (a handful of rows) is read only when a non-default sale type is selected.
export const applyEstimateSaleTypeCustomer = async (cartData, tillData) => {
  if (!saleTypeCustomerFor(usePOSConfigStore.getState().saleTypeData)) return false;
  const saleTypeCustomerIds = await loadSaleTypeCustomerIds();
  const customer = resolveEstimateSaleTypeCustomer(cartData, tillData, saleTypeCustomerIds);
  if (!customer) return false;
  trace("EST-SALETYPE", "estimate walk-in replaced by sale type customer", {
    estimateId: cartData?.estimateId,
    saleType: usePOSConfigStore.getState().saleTypeData?.cwrSaletype?.name,
    from: cartData?.customer?.cwrCustomerId || null,
    to: customer.cwrCustomerId,
  });
  cartData.customer = customer;
  return true;
};
